module.exports = __webpack_public_path__ + "img/img07.647149ba.svg";